import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AlarmDetailsComponent } from './alarm-details/alarm-details.component';
import { WelcomePageComponent } from './welcome-page/welcome-page.component';
import { CoordinatorComponent } from './coordinator/coordinator.component';
import { RulesOverviewComponent } from './factory-summary/rules-overview/rules-overview.component';
import { HealthIndicatorComponent } from './health-indicator/health-indicator.component';
import { WorkCenterViewComponent } from './work-center-view/work-center-view.component';
import { RuleCreationChatPageComponent } from './rule-creation-chat-page/rule-creation-chat-page.component';
import { KpiDashboardComponent } from './kpi-dashboard/kpi-dashboard.component';

const routes: Routes = [
  { path: 'factory', component: RulesOverviewComponent },
  { path: 'factory/rule', component: AlarmDetailsComponent },
  { path: 'homepage', component: WelcomePageComponent },
  { path: 'coordinator', component: CoordinatorComponent },
  { path: 'coordinator/operational-view', component: CoordinatorComponent },
  { path: 'health-indicator', component: HealthIndicatorComponent },
  { path: 'work-center-view', component: WorkCenterViewComponent },
  { path: '', redirectTo: 'factory', pathMatch: 'full' },
  { path: 'rule-creation-chat', component: RuleCreationChatPageComponent },
  { path: 'kpi-dashboard', component: KpiDashboardComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FeaturesRoutingModule {}
